import { useState } from "react";
import PedigreeTree from "./PedigreeTree.jsx";
import ProgenyTree from "./ProgenyTree.jsx";

const PedigreeTabs = ({ horse, pedigreeTree, progenyTree }) => {
  const [tab, setTab] = useState("pedigree");
  const tabBase = "px-5 py-2.5 text-sm font-bold border-b-2 transition-colors";
  const activeCls = "border-[#B8860B] text-[#B8860B]";
  const inactiveCls = "border-transparent text-[#5C4F42] hover:text-[#1B3B5A]";

  return (
    <div className="w-full">
      <div className="flex justify-center border-b border-[#D6CFC4] mb-5" data-testid="pedigree-tabs">
        <button
          type="button"
          onClick={() => setTab("pedigree")}
          className={`${tabBase} ${tab === "pedigree" ? activeCls : inactiveCls}`}
          data-testid="tab-pedigree"
        >
          Удмын мод
        </button>
        <button
          type="button"
          onClick={() => setTab("progeny")}
          className={`${tabBase} ${tab === "progeny" ? activeCls : inactiveCls}`}
          data-testid="tab-progeny"
        >
          Үр төлийн мод
        </button>
      </div>

      {tab === "pedigree" ? (
        pedigreeTree && (pedigreeTree.father || pedigreeTree.mother) ? (
          <PedigreeTree tree={pedigreeTree} horse={horse} />
        ) : (
          <div className="text-center py-10 text-[#5C4F42]" data-testid="pedigree-empty">
            <div className="text-lg font-bold mb-1">Эцэг эхийн мэдээлэл бүртгэгдээгүй байна.</div>
          </div>
        )
      ) : progenyTree && progenyTree.children && progenyTree.children.length > 0 ? (
        <ProgenyTree tree={progenyTree} />
      ) : (
        <div className="text-center py-10 text-[#5C4F42]" data-testid="progeny-empty">
          <div className="text-lg font-bold mb-1">Үр төлийн мэдээлэл бүртгэгдээгүй байна.</div>
        </div>
      )}
    </div>
  );
};

export default PedigreeTabs;
